export default "__VITE_ASSET__BOTqsr6V__"